
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import ActivityList from './pages/ActivityList';
import AuthProvider from './components/AuthProvider';
import ApiAuthChecker from './components/ApiAuthChecker';
import ApiUrl from './pages/ApiUrl';
import SignIn from './pages/SignIn';
import ActivityDetails from './pages/ActivityDetails';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path='/' element={<ApiAuthChecker />} />
          <Route path='/activity-list' element={<ActivityList />} />
          <Route path='/activity-details-add' element={<ActivityDetails mode="add" />} />
          <Route path='/activity-details-edit/:id' element={<ActivityDetails mode="edit" />} />
          <Route path='/api-url' element={<ApiUrl />} />
          <Route path='/signin' element={<SignIn />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
